import { useCallback } from "react";
import { GoogleSignupButton } from "../Home/Signup/GoogleSignupButton";
import { LicenseInviteState } from "./types";
import { processLoginResponse } from "../../../utils/auth/processLoginResponse";
import { useUserContext } from "../../../shared/contexts/UserContext";

export const InviteGoogleAuth: React.FC<{
  accountType: "parent" | "learner";
  setInviteState: (state: LicenseInviteState) => void;
}> = ({ accountType, setInviteState }) => {
  const userContext = useUserContext();

  const handleGoogleSignup = useCallback(
    (success: boolean, data: any) => {
      if (success) {
        processLoginResponse(data, userContext, false);
        setInviteState({ state: "acceptInvite" });
      }
    },
    [setInviteState, userContext]
  );

  return (
    <GoogleSignupButton
      forceAccountType={accountType}
      onSignup={handleGoogleSignup}
    />
  );
};
